/**
 * Database name prefix for offline editor databases.
 */
export const OFFLINE_STEPS_DATABASE_NAME_PREFIX = 'editor:offline-steps-';

/**
 * IndexedDB object store name for metadata.
 */
export const OFFLINE_META_STORE_NAME = 'meta';

/**
 * IndexedDB object store name for steps.
 */
export const OFFLINE_STEPS_STORE_NAME = 'steps';
